import React from 'react'
import clsx from 'clsx'
import { withStyles } from '@material-ui/core/styles'
import { FormattedMessage } from 'react-intl'
import Assets from 'app/configs/assetConfigs'
import * as R from 'ramda'
import PrimaryButton from 'app/components/buttons/PrimaryButton'
import { Typography, makeStyles, FormControlLabel } from '@material-ui/core'
import { Routes } from 'app/services/routeService/routeService'
import RichTextDisplay from 'app/components/richTextEditor/RichTextDisplay'
import { useAppLogo } from 'commons/usePartner'

const styles = (theme) => ({
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
})

const useStyles = makeStyles((theme) => ({
  rootRedemptionPage: {
    overflowY: 'scroll',
  },
  redemptionTitle: {
    height: '25%',
    minHeight: '100px',
    '& label': {
      margin: 0,
    },
  },
  titleText: {
    color: '#064e75',
  },
  redemptionNotification: {
    height: '20%',
    minHeight: '100px',
  },
  notificationTitle: {
    color: '#00adee',
  },
  notificationSubTitle: {
    color: '#064e75',
  },
  redemptionIcons: {
    height: '40%',
    minHeight: '230px',
  },
  unsuccessfulText: {
    color: '#f74872',
  },
  redemptionActions: {
    height: '15%',
    minHeight: '100px',
  },
  voucherIdText: {
    color: '#a8a8a8',
  },
  btnApprove: {
    borderRadius: '1rem',
  },
}))

const RedemptionUnsuccessful = (props) => {
  const {
    user,
    voucher,
    voucherTitle,
    history,
    isNotificationNotFound,
    message,
  } = props
  const { logo } = useAppLogo()
  const classes = useStyles()
  const handleDone = () => {
    history.push(Routes.notificationTimeline())
  }

  return (
    <>
      <div className={clsx('h-full', classes.rootRedemptionPage)}>
        <div className={clsx(classes.redemptionTitle, 'text-center py-10')}>
          <FormControlLabel
            control={<img className="w-36" src={logo} alt="logo" />}
            label={
              <div
                className={clsx(
                  classes.titleText,
                  'p-5 font-bold text-2xl sm:text-3xl md:text-5xl',
                )}
              >
                <FormattedMessage id="redemption.voucher.redemption" />
              </div>
            }
            disabled={true}
          />
        </div>
        <div className={clsx(classes.redemptionNotification, 'text-center')}>
          <div
            className={clsx(
              classes.notificationTitle,
              'font-bold text-3xl sm:text-4xl md:text-6xl',
            )}
          >
            <RichTextDisplay text={voucherTitle} />
          </div>
          {!isNotificationNotFound && (
            <Typography
              className={clsx(
                classes.notificationSubTitle,
                'text-base sm:text-1xl',
              )}
            >
              <FormattedMessage
                id="redemption.voucher.name"
                values={{
                  firstName: R.prop('firstName', user),
                  lastName: R.prop('lastName', user),
                }}
              />
            </Typography>
          )}
        </div>
        <div className={clsx(classes.redemptionIcons, 'text-center')}>
          <div className="m-auto w-2/6 sm:w-1/6">
            <img
              className="w-full"
              src={Assets.redemption.cancel}
              alt="Icon cancel"
            />
          </div>
          <Typography
            className={clsx(
              classes.unsuccessfulText,
              'font-bold text-2xl sm:text-4xl md:text-5xl',
            )}
          >
            <FormattedMessage id="redemption.voucher.redemption.unsuccessful" />
          </Typography>
          {!R.isNil(message) && (
            <Typography
              className={clsx(
                classes.unsuccessfulText,
                'text-base sm:text-2xl md:text-lg',
              )}
            >
              {message}
            </Typography>
          )}
        </div>
        <div className={clsx(classes.redemptionActions, 'text-center')}>
          <div
            className={clsx(
              classes.voucherIdText,
              'text-xs p-5 sm:text-lg md:text-base',
            )}
          >
            <FormattedMessage
              id="redemption.voucher.redemption.voucherId"
              values={{
                id: voucher.voucherId,
              }}
            />
          </div>
          <PrimaryButton
            className={clsx(classes.btnApprove, 'w-2/3 sm:text-1xl')}
            onClick={handleDone}
            inputProps={{
              'data-testid': 'doneRedemptionBtn',
            }}
          >
            <FormattedMessage id="action.done" />
          </PrimaryButton>
        </div>
      </div>
    </>
  )
}

export default withStyles(styles, { withTheme: true })(RedemptionUnsuccessful)
